import { render, staticRenderFns } from "./LegalInformation.vue?vue&type=template&id=baf689fa&scoped=true&"
import script from "./LegalInformation.vue?vue&type=script&lang=js&"
export * from "./LegalInformation.vue?vue&type=script&lang=js&"
import style0 from "./LegalInformation.vue?vue&type=style&index=0&id=baf689fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baf689fa",
  null
  
)

export default component.exports